exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".carousel-control[_v-1de42027] {\n  cursor: pointer;\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=_v-1de42027&file=Carousel.vue&scoped=true!./~/vue-loader/lib/selector.js?type=style&index=0!./src/Carousel.vue
// module id = 115
// module chunks = 0